module.exports = " <input type=hidden :name=name v-model=data /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/HiddenFieldtype.vue
// module id = 687
// module chunks = 0